import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'job-form-buttons',
  templateUrl: './job-form-buttons.component.html',
  styleUrls: ['./job-form-buttons.component.scss']
})
export class JobFormButtonsComponent {
  @Input() validationMessage: string = '';
  @Input() showValidationMessage: boolean = false;
  @Input() applyDisabled: boolean = false;
  @Input() currentJobDisableEdit: boolean = false;
  @Input() applyButtonText: string = 'GLOBAL.APPLY';
  @Input() cancelButtonText: string = 'GLOBAL.CANCEL';

  @Output() apply = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  get isApplyDisabled(): boolean {
    return this.applyDisabled || this.currentJobDisableEdit || this.showValidationMessage;
  }

  onApplyClick(): void {
    this.apply.emit();
  }

  onCancelClick(): void {
    this.cancel.emit();
  }
}
